import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSession } from '@/app/providers/session-provider';
import AssetImage from '../../../shared/assets/AssetImage';
import './auth.css';

export default function AdminLoginPage() {
  const {
    isAuthenticated,
    loginPlatformAdmin,
    isAuthenticating,
    authError,
    canAccessPlatformAdmin,
    isWorkspaceAccess,
  } = useSession();
  const [form, setForm] = useState({
    email: '',
    password: '',
  });
  const [submitError, setSubmitError] = useState('');

  if (isAuthenticated) {
    return <Navigate to={canAccessPlatformAdmin && !isWorkspaceAccess ? '/admin/tenants' : '/'} replace />;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitError('');

    try {
      await loginPlatformAdmin(form);
    } catch (error) {
      setSubmitError(error.message || 'Accesso admin non riuscito');
    }
  }

  return (
    <main className="auth-page">
      <section className="auth-shell" aria-label="Accesso amministratore Webtika">
        <div className="auth-logo-frame">
          <AssetImage srcKey="brand.logoHorizontal" alt="Webtika" className="auth-logo" />
        </div>

        <div className="auth-card">
          <header className="auth-card__header">
            <p className="auth-card__eyebrow">Platform Admin</p>
            <h1 className="auth-card__title">Accesso Admin</h1>
            <p className="auth-card__description">
              Entra nel control plane con un account autorizzato `SUPER_ADMIN`.
            </p>
          </header>

          {submitError || authError ? (
            <div className="auth-alert wt-inline-error" role="alert">
              <strong>Accesso admin non riuscito</strong>
              <span>{submitError || authError}</span>
            </div>
          ) : null}

          <form className="auth-form" onSubmit={handleSubmit}>
            <label className="auth-field" htmlFor="admin-login-email">
              <span>Email</span>
              <input
                id="admin-login-email"
                className="auth-input"
                type="email"
                value={form.email}
                onChange={(event) => setForm((prev) => ({ ...prev, email: event.target.value }))}
                autoComplete="email"
              />
            </label>

            <label className="auth-field" htmlFor="admin-login-password">
              <span>Password</span>
              <input
                id="admin-login-password"
                className="auth-input"
                type="password"
                value={form.password}
                onChange={(event) => setForm((prev) => ({ ...prev, password: event.target.value }))}
                autoComplete="current-password"
              />
            </label>

            <button type="submit" className="auth-submit" disabled={isAuthenticating}>
              {isAuthenticating ? 'Accesso admin in corso...' : 'Accedi al control plane'}
            </button>
          </form>

          <p className="auth-helper">Sessione separata dal workspace cliente.</p>
        </div>
      </section>
    </main>
  );
}
